
  import { defineComponent, PropType } from 'vue';

  import Tooltip from '@/common/ui/Tooltip.vue';

  import { SectionTitleModes, TSectionTitleLevel } from './types';

  export default defineComponent({
    name: 'SectionTitle',
    components: { Tooltip },
    props: {
      text: {
        type: String,
        default: '',
      },
      level: {
        type: Number as PropType<TSectionTitleLevel>,
        default: 3,
      },
      tooltipContent: {
        type: String,
        default: '',
      },
      mode: {
        type: String as PropType<SectionTitleModes>,
        default: SectionTitleModes.DEFAULT,
      },
    },
    computed: {
      titleTag(): `h${TSectionTitleLevel}` {
        return `h${this.level}`;
      },
      titleClass() {
        return [
          `section-title__text--h${this.level}`,
          {
            'section-title__text--background': this.mode === SectionTitleModes.BACKGROUND,
          },
        ];
      },
    },
  });
